import { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import SupportLink from 'src/components/intercom/SupportLink';
import { useFormContext } from 'react-hook-form';
import useFetchLocale from '../hooks/useFetchLocale';
import useCheckEU from '../hooks/useCheckEU';

export default function LocationCheck() {
  const { register, watch, setValue } = useFormContext();

  register('address', {});
  register('isUAE', {});
  register('isEuropeanUnion', {});

  const country = watch('country');

  const { countryCode: ipCountry } = useFetchLocale();

  const isUAE = ipCountry === 'AE' || country === 'AE';

  const isEuropeanUnion = useCheckEU(country);

  useEffect(() => {
    if (!ipCountry) return;
    setValue('country', ipCountry);
  }, [setValue, ipCountry]);

  useEffect(() => {
    setValue('isUAE', isUAE);
  }, [setValue, isUAE]);

  useEffect(() => {
    setValue('isEuropeanUnion', isEuropeanUnion);
  }, [setValue, isEuropeanUnion]);

  if (isUAE)
    return (
      <Box my="20px" color="podcastRed600">
        We cannot accept signups from UAE. Please{' '}
        <SupportLink
          message="Help! I can't sign up to Alitu because my address is in UAE."
          color="inherit"
        >
          contact support
        </SupportLink>{' '}
        for more details.
      </Box>
    );

  return null;
}
